export const getArrayErrorsFromResponse = (data) => {
  const errors = []
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      errors.push(...data[key])
    }
  }
  return errors
}